import { render, staticRenderFns } from "./account_supdeduct_detail.vue?vue&type=template&id=6c759848&scoped=true"
import script from "./account_supdeduct_detail.vue?vue&type=script&lang=js"
export * from "./account_supdeduct_detail.vue?vue&type=script&lang=js"
import style0 from "./account_supdeduct_detail.vue?vue&type=style&index=0&id=6c759848&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c759848",
  null
  
)

export default component.exports